import axios from "axios";
import constants from "@/config/constants";
import _ from "lodash";
import moment from "moment"


function initialState() {
    return {
        all: [],
        loading: false,
        languages:[]
    }
}

const getters = {
   
    all         :   state => state.all,
    total       :   state => state.all.length,
    loading     :   state => state.loading,
    languages   :   state => state.languages
}

const actions = {
    fetchData({ commit, state ,dispatch}, params) {
        commit('setLoading', true)
        const headers = {
            'Authorization': 'Bearer ' + localStorage.getItem('token')
        };
       
        axios.get(`${constants.API_URL}/api/event-page/event-id/${params}`,{ headers: headers })
            .then(response => {
                commit('setAll', response.data.data)
                dispatch('setAllLanguages',params)

            })
            .catch(error => {
                let message = error.response.data.message || error.message
                commit('setError', message)
            })
            .finally(() => {
                commit('setLoading', false)
            })
    },
    destroyData({ commit, state }, id) {
        const headers = {
            'Authorization': 'Bearer ' + localStorage.getItem('token')
        };

        return axios.delete(constants.API_URL + '/api/event-page/' + id, {headers: headers})
            .then(response => {
                commit('setAll', state.all.filter((item) => {
                    return item.id != id
                }))
                return response;
            })
            .catch(error => {
                const message = error.response.data.message || error.message
                commit('setError', message)
                console.log(error)
            }).finally(() => {
                commit('setLoading', false)
            })
    },
    
    setAllLanguages({commit,state},event_id){
        const headers = {
            'Authorization': 'Bearer ' + localStorage.getItem('token')
        };
        axios.get(`${constants.API_URL}/api/events/event-id/${event_id}`, {headers: headers})
        .then(response => {
            let eventInfo = response.data.data;
            let eventLanguages = _.map(_.map(eventInfo.languages, 'language_id'), 'language');
            commit('setLanguages', eventLanguages);
                   

        })
        .catch(error => {
            let message = error.response.data.message || error.message
            commit('setError', message)
        })
        .finally(() => {
            commit('setLoading', false)
        })
       
    },
    
    resetState({ commit }) {
        commit('resetState')
    }
}

const mutations = {
    setAll(state, items) {
        state.all = items
    },
    setLoading(state, loading) {
        state.loading = loading
    },
    resetState(state) {
        state = Object.assign(state, initialState())
    },
    setLanguages(state,item){
        state.languages = item
    }
}

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations
}
